import type { VariableNameType, TsTypeType, TsCodeType } from '../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { BoVisitor } from '../bos/bo-visitor.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

@jsonClass('Parameter')
export class Parameter {
	@jsonProperty(String) name!: VariableNameType
	@jsonProperty(String) type!: TsTypeType
	@jsonProperty(String) defaultExpression!: TsCodeType

	constructor(init?: Partial<Parameter>) {
		assignCommonProperties(this, init)
	}

	visit(visitor: BoVisitor, pathPrefix: (string | number)[]): void {
		visitor.visitTsCode(
			this.defaultExpression,
			this,
			'input',
			[...pathPrefix, 'defaultExpression'],
			(newCode) => (this.defaultExpression = newCode),
		)
		visitor.visitTsCode(
			this.type,
			this,
			'type',
			[...pathPrefix, 'type'],
			(newType) => (this.type = newType),
		)
	}

	getSignature(
		makeReadonly: boolean,
		allowDefaultAssignment = true,
		allowQuestionMarkModifier = false,
	) {
		return `${this.name}${allowQuestionMarkModifier && this.defaultExpression ? '?' : ''}: ${makeReadonly ? `DeepReadonly<${this.type}>` : this.type}${this.defaultExpression && allowDefaultAssignment ? ` = ${this.defaultExpression}` : ''}`
	}

	getConversionFromString(expression: string) {
		if (this.type == 'number') return `parseFloat(${expression})`
		if (this.type == 'boolean') return `!!(${expression})`
		if (this.type == 'Date') return `new Date(${expression})`
		return expression
	}
}
